export enum ScriptType {
  Transformation = 1,
  Query = 2,
}

export enum EndpointType {
  CRD = 1,
  DTR = 2,
  PAS = 3,
}

export const EndpointTypeNames: Record<EndpointType, string> = {
  [EndpointType.CRD]: 'CRD',
  [EndpointType.DTR]: 'DTR',
  [EndpointType.PAS]: 'PAS',
};

export enum EndpointSubtype {
  CRD_APPOINTMENT_BOOK = 1,
  CDR_ORDER_SIGN = 2,
  DTR_QUESTIONNAIRE_PACKAGE = 3,
  DTR_NEXT_QUESTION = 4,
  DTR_EXPAND = 5,
  DTR_LOG_QUESTIONNAIRE_ERRORS = 6,
  PAS_SUBMIT = 7,
  PAS_SUBMIT_ATTACHMENT = 8,
  PAS_INQUIRE = 9,
}

export const EndpointSubtypeNames: Record<EndpointSubtype, string> = {
  [EndpointSubtype.CRD_APPOINTMENT_BOOK]: 'appointment-book',
  [EndpointSubtype.CDR_ORDER_SIGN]: 'order-sign',
  [EndpointSubtype.DTR_QUESTIONNAIRE_PACKAGE]: '$questionnaire-package',
  [EndpointSubtype.DTR_NEXT_QUESTION]: '$next-question',
  [EndpointSubtype.DTR_EXPAND]: '$expand',
  [EndpointSubtype.DTR_LOG_QUESTIONNAIRE_ERRORS]: '$log-questionnaire-errors',
  [EndpointSubtype.PAS_SUBMIT]: '$submit',
  [EndpointSubtype.PAS_SUBMIT_ATTACHMENT]: '$submit-attachment',
  [EndpointSubtype.PAS_INQUIRE]: '$inquire',
};

export const EndpointSubtypeToType: Record<EndpointSubtype, EndpointType> = {
  [EndpointSubtype.CRD_APPOINTMENT_BOOK]: EndpointType.CRD,
  [EndpointSubtype.CDR_ORDER_SIGN]: EndpointType.CRD,
  [EndpointSubtype.DTR_QUESTIONNAIRE_PACKAGE]: EndpointType.DTR,
  [EndpointSubtype.DTR_NEXT_QUESTION]: EndpointType.DTR,
  [EndpointSubtype.DTR_EXPAND]: EndpointType.DTR,
  [EndpointSubtype.DTR_LOG_QUESTIONNAIRE_ERRORS]: EndpointType.DTR,
  [EndpointSubtype.PAS_SUBMIT]: EndpointType.PAS,
  [EndpointSubtype.PAS_SUBMIT_ATTACHMENT]: EndpointType.PAS,
  [EndpointSubtype.PAS_INQUIRE]: EndpointType.PAS,
};

export enum InputType {
  JSON = 1,
}

export const InputTypeNames: Record<InputType, string> = {
  [InputType.JSON]: 'JSON',
};

export interface Script {
  id: string;
  name: string;
  description: string;
  endpointTypeId: EndpointType;
  endpointSubtypeIds: EndpointSubtype[];
  inputTypeId: InputType;
  javascriptCode: string;
  sampleData?: string;
  lastModifiedDate: string | null;
  isActive?: boolean;
}

export interface FetchScriptsParams {
  pageNumber?: number;
  pageSize?: number;
  orderBy?: string;
  orderByDesc?: boolean;
  search?: string;
  endpointTypeId?: EndpointType | '';
  endpointSubtypeId?: EndpointSubtype | '';
  inputTypeId?: InputType | '';
}

export interface ScriptRunPayload {
  options: {
    isConsoleOutputEnabled: boolean;
  };
  data: string;
}

export interface ScriptTestItem {
  id: string;
  name: string;
  scriptId: string;
  scriptName: string;
  sample: string;
  target: string;
  output?: string;
  validationMessage?: string;
  status?: 'pending' | 'running' | 'pass' | 'fail';
}

export const getDefaultScript = (): Omit<Script, 'id'> => ({
  name: '',
  description: '',
  endpointTypeId: EndpointType.CRD,
  endpointSubtypeIds: [],
  inputTypeId: InputType.JSON,
  javascriptCode: '',
  sampleData: '{}',
  lastModifiedDate: null,
});

export const enum RunButtonState {
  Run = 'Run',
  Running = 'Running',
  Success = 'Success',
  Error = 'Error',
}

export type FormState = {
  name: string;
  description: string;
  javascriptCode: string;
  sampleData: string;
  endpointTypeId: EndpointType;
  endpointSubtypeIds: EndpointSubtype[];
  inputTypeId: InputType;
};
